module.exports = __webpack_public_path__ + "img/ossp_logo.7d413250.png";